import humanizeDuration from 'humanize-duration';
const defaultUnits = ['h', 'm', 's'];
export const getDuration = (duration, language = 'en', timeFormat, units = defaultUnits, round = false, delimiter = ' ', spacer = timeFormat ? '' : ' ') => {
  const opts = {
    language,
    units,
    delimiter,
    spacer,
    ...(timeFormat && {
      languages: {
        [language]: {
          d: () => timeFormat.day || 'days',
          h: () => timeFormat.hour || 'h',
          m: () => timeFormat.minute || 'min',
          s: () => timeFormat.second || 's'
        }
      }
    }),
    round
  };
  return humanizeDuration(duration, opts);
};
//# sourceMappingURL=durationUtil.js.map